import { get, post, urlApi, urlPath } from "../api";

const url = urlApi + "generatePayment";

export const generatePayment = async (obj, token = "") => {
  let response = null;
  let status = 200;

  const request = {
    method: "POST",
    body: JSON.stringify(obj),
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  };

  await fetch(url, request)
    .then((res) => {
      status = res.status;
      if (res.status === 200) {
        return res.json();
      }
    })
    .then((res) => {
      if (res) {
        response = res;
      }
    })
    .catch((err) => {
      status = err.status;
      return null;
    });

  return { response, status };
};
